import axios from "axios";
import {useQuery} from "@tanstack/vue-query";
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";

const staleTime = 1000 * 60 * 24;

const getActions = (type) => {
  const store = useStore();
  const monthsFilter = computed(() => store?.getters['actions/monthsFilter']);
  const endpoint = ref('/ajax/v2/actions');

  let queryKey = ['actions', type];

  watch(
    monthsFilter,
    () => {
      if (type.value === 'completed') {
        queryKey.push(monthsFilter);
        endpoint.value = `/ajax/v2/actions/completed/${monthsFilter.value}`;
      }

      if (type.value === 'active') {
        endpoint.value = `/ajax/v2/actions?live=true`;
      }
    },
    {
      immediate: true
    }
  );

  return useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      const {data} = await axios.get(endpoint.value);

      return data.data;
    },
    staleTime,
  });
};

const removeActionById = (activeTab, queryClient, actionId, fieldToCheck = 'id') => {
  const previousActions = queryClient.getQueryData(['actions', activeTab]);

  queryClient.setQueryData(['actions', activeTab], (old) => old ? old.filter(action => action[fieldToCheck] !== actionId) : []);

  return previousActions;
};

const removePageActionById = (activeTab, queryClient, actionId, fieldToCheck = 'id') => {
  const previousActions = queryClient.getQueryData(['actions', activeTab]);

  const newPagesArray = previousActions.pages.map((page) => ({
    ...page,
    data: page.data.map((pageModel) => {
      const updatedPageModel = {
        ...pageModel,
          actions: pageModel.actions.filter((action) => action[fieldToCheck] !== actionId),
      };
      // Set to null to remove the page from the data if there are no actions remaining for the page
      return updatedPageModel.actions.length > 0 ? updatedPageModel : null;
    }).filter(pageModel => pageModel !== null),
  }));

  queryClient.setQueryData(['actions', activeTab], (data) => ({
    pages: newPagesArray,
    pageParams: data.pageParams,
  }));

  return previousActions;
};

const filterOutActionFromQueryDataById = (activeTab, queryClient, actionId, fieldToCheck) => {
  switch (activeTab.value) {
    case 'page':
     return removePageActionById(activeTab, queryClient, actionId, fieldToCheck);
    case 'category':
      // Note for future reference: Filtering out for categories is not ideal due to pagination. Explained on HIKE-3447
      return;
    default:
      return removeActionById(activeTab, queryClient, actionId, fieldToCheck);
  }
};

export {
  getActions,
  filterOutActionFromQueryDataById,
};
